import moment from 'moment-timezone';

import { expVal } from '@confluence/feature-experiments';

export const isValidTimeZone = (timeZone: string): boolean => {
	if (expVal('confluence_migrate_moment_to_native', 'isEnabled', false)) {
		try {
			Intl.DateTimeFormat(undefined, { timeZone });
			return true;
		} catch {
			return false;
		}
	}

	return moment.tz.zone(timeZone) !== null;
};
